import { clsx } from '@wonderful/wwc/dist/src/helpers/clsx';
import DOMPurify from 'isomorphic-dompurify';
import { useState } from 'react';
import { BuilderEditingHelper } from '@wonderful/wwc/dist/src/common/BuilderEditingHelper/BuilderEditingHelper';
import Section from '@/components/design/Section/Section';
import { DesignType, TextBoxProps } from './TextBox.types';
import styles from './TextBox.module.scss';

const TextEditor = ({ design, body }: TextBoxProps) => {
  const isVisible = !body;
  const [isInViewport, setIsInViewport] = useState(false);
  const onEnterViewport = () => {
    setIsInViewport(true);
  };

  return (
    <Section
      className={clsx(
        'container',
        design === DesignType.legalPage && styles.legalPage,
        design !== DesignType.legalPage
          ? isInViewport && styles.isInViewport
          : ''
      )}
      onEnterViewport={onEnterViewport}
    >
      <div className="row">
        <div className={clsx(styles.text)}>
          {body && (
            <div
              className="richtext"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }}
            />
          )}
        </div>
      </div>
      <BuilderEditingHelper componentName="TextBox" visible={isVisible} />
    </Section>
  );
};

export default TextEditor;
